<script>
    import { movable } from '@svelte-put/movable';

    const draggable = true;
    const throttleDrag = 1;
    const edgeDraggable = false;
    const startDragRotate = 0;
    const throttleDragRotate = 0;
    const scalable = true;
    const keepRatio = false;
    const throttleScale = 0;
    const snappable = true;
    const bounds = {"left":0,"top":0,"right":0,"bottom":0,"position":"css"};
    let targetRef = null;
    let moveableRef = null;
</script>
<div class="root">
    <div
            class="container flex"
            bind:this={targetRef}
            style="width: 500px;height: 50px;border: 1px solid #ccc;"
    >

        <div  class="h" id="1" on:movableend={given => {console.log(given)}}  use:movable={{limit: {parent:targetRef}}}
                >move me</div>
        <div  class="h" id="2" on:movableend={given => {console.log(given)}}  use:movable={{limit: {parent:targetRef}}}
        >move me 2</div>
    </div>
</div>

<style>
    .h{
        height: 50px;
    }
</style>